<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
    <form class="kt-form w-webkit-fill-available" [formGroup]="form">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ data.mode === 'edit' ? ('Edit' ) : 'Create' }} {{ 'Domain URL' }}</h5>
          <span class="modal-x-button" (click)="onCloseDialog()">
            <i class="fa fa-times" aria-hidden="true"></i>
          </span>
        </div>
        <div class="modal-body">
            <div class="col-12 form-group row">
              <label class="col-4 control-label">{{ 'Region' }}</label>
              <input type="text" class="col-8 form-control" [value]="data?.domainURL?.region || '-'" disabled>
            </div>

            <div class="domain-section">
              <h6 class="section-title">Primary</h6>

              <div class="col-12 form-group row">
                <label class="col-4 control-label">Landing<span class="text-danger">*</span></label>
                <textarea formControlName="primary_landing" class="col-8 form-control" rows="3" placeholder="Comma or newline separated domains"></textarea>
              </div>

              <div class="col-12 form-group row">
                <label class="col-4 control-label">Main<span class="text-danger">*</span></label>
                <input type="text" formControlName="primary_main" class="col-8 form-control" placeholder="Single domain only">
              </div>

              <div class="col-12 form-group row mb-0">
                <label class="col-4 control-label">Active</label>
                <textarea formControlName="primary_active" class="col-8 form-control" rows="4" placeholder="Comma or newline separated domains"></textarea>
              </div>
            </div>

            <div class="domain-section mt-4">
              <h6 class="section-title">Hidden</h6>

              <div class="col-12 form-group row">
                <label class="col-4 control-label">Landing<span class="text-danger">*</span></label>
                <textarea formControlName="hidden_landing" class="col-8 form-control" rows="3" placeholder="Comma or newline separated domains"></textarea>
              </div>

              <div class="col-12 form-group row">
                <label class="col-4 control-label">Main<span class="text-danger">*</span></label>
                <input type="text" formControlName="hidden_main" class="col-8 form-control" placeholder="Single domain only">
              </div>

              <div class="col-12 form-group row mb-0">
                <label class="col-4 control-label">Active</label>
                <textarea formControlName="hidden_active" class="col-8 form-control" rows="4" placeholder="Comma or newline separated domains"></textarea>
              </div>
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="onCloseDialog()"><i class="fas fa-ban"></i>{{ 'Close' }}</button>
          <kt-submit-button canEditDomainURL [isDisabled]="!form.valid" [buttonLoading]="buttonLoading" (confirmed)="onSave()"></kt-submit-button>
        </div>
      </div>
    </form>
  </div>
  <kt-swal-alert [message]="messages$ | async" (confirmed)="onCloseDialog(true)"></kt-swal-alert>
